import type { ILoginResponse } from '@/types/ILogin';
import type { IAPIRes } from '@/types/IAPIRes';
import { useAxios } from '@/boot/axios';
import { useAuthStore } from '@/stores/auth';

export const getDataFresh = async (): Promise<IAPIRes<ILoginResponse>> => {
  const { axiosAuth } = useAxios();
  const response = await axiosAuth.get<IAPIRes<ILoginResponse>>('/fresh/stored-data');
  const authStore = useAuthStore(); 

  authStore.setUserName(response.data.data.name);
  authStore.setIsAgent(response.data.data.is_agent);
  authStore.setId(response.data.data.id);
  authStore.setIsUserVerified(response.data.data.is_user_verified);
  authStore.setSlug(response.data.data.slug);
  authStore.setIsHaveSubscription(response.data.data.is_have_subscription);
  authStore.setReviewTotal(response.data.data.review_total);
  authStore.setReviewLikesTotal(response.data.data.review_likes_total);
  authStore.setReviewViewsTotal(response.data.data.review_views_total);
  authStore.setCountry(response.data.data.country);
  authStore.setHasBankAccount(response.data.data.has_bank_account);

  return response.data;
};


